var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77778 0C1.2485 0 0 1.2485 0 2.77778V17.2222C0 18.7515 1.2485 20 2.77778 20H17.2222C18.7515 20 20 18.7515 20 17.2222V2.77778C20 1.2485 18.7515 0 17.2222 0H2.77778ZM2.77778 1.11111H17.2222C18.1552 1.11111 18.8889 1.84484 18.8889 2.77778V15.7292L15.4709 10.2604C15.4209 10.1807 15.3515 10.1149 15.2691 10.0694C15.1867 10.0238 15.0941 9.99996 15 10C14.9059 9.99996 14.8133 10.0238 14.7309 10.0694C14.6485 10.1149 14.5791 10.1807 14.5291 10.2604L11.8424 14.5595L7.69097 8.03603C7.6421 7.95883 7.57494 7.89487 7.49545 7.84983C7.41596 7.80478 7.32658 7.78003 7.23524 7.77778C7.14367 7.77551 7.05295 7.79592 6.97116 7.83719C6.88938 7.87846 6.81907 7.93931 6.76649 8.01432L1.11111 16.0916V2.77778C1.11111 1.84484 1.84484 1.11111 2.77778 1.11111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaPreviewIcon);
export default __webpack_public_path__ + "static/media/socialMediaPreviewIcon.6a2e7731ae8e85a768b2cd802468cf6f.svg";
export { ForwardRef as ReactComponent };